// Playback speeds as the video settings menu lists them, shared by the post's
// video chrome and the dock's cinema transport.

export const DEFAULT_VIDEO_PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2]

export function normalizePlaybackRate(value: unknown): number | null {
    const numeric = Number(value)
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null
}

export function formatPlaybackRateLabel(rate: unknown): string {
    const normalizedRate = normalizePlaybackRate(rate) ?? 1
    if (Math.abs(normalizedRate - 1) < 0.001) return '1x'
    return `${
        Number.isInteger(normalizedRate)
            ? normalizedRate
            : normalizedRate.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
    }x`
}

/**
 * The rates a menu lists: the offered ones, deduplicated and sorted, with the
 * current rate added when it is not among them (a runtime can report one the
 * list does not carry) so the menu always has a checked row.
 */
export function normalizePlaybackRates(rates: unknown, currentRate: unknown = 1): number[] {
    const baseRates = Array.isArray(rates) && rates.length ? rates : DEFAULT_VIDEO_PLAYBACK_RATES
    const normalizedRates = baseRates
        .map(normalizePlaybackRate)
        .filter((rate): rate is number => rate != null)
        .filter(
            (rate, index, list) => list.findIndex(item => Math.abs(item - rate) < 0.001) === index,
        )
        .sort((left, right) => left - right)
    const normalizedCurrentRate = normalizePlaybackRate(currentRate)

    if (
        normalizedCurrentRate != null &&
        !normalizedRates.some(rate => Math.abs(rate - normalizedCurrentRate) < 0.001)
    ) {
        normalizedRates.push(normalizedCurrentRate)
        normalizedRates.sort((left, right) => left - right)
    }

    return normalizedRates.length ? normalizedRates : DEFAULT_VIDEO_PLAYBACK_RATES
}
